<div class="filter-panel--option text-filter--component">
    <ion-label stacked>{{ label }}</ion-label>
    <ion-input type="text"
               [(ngModel)]="input"
               [formControl]="formControl"
               [placeholder]="placeholder"></ion-input>
    <div class="clearfix"></div>
</div>
